<template>
  <div @click="goToProfile" class="user-item clearAfterFloats">
    <div class="user-item-header clearAfterFloats">
      <div class="img-container">
        <img :src="user.PhotoUrl" alt="Slika korisnika" />
        <!-- <img class="default-image" src="https://img.icons8.com/metro/50/000000/user-male-circle.png"> -->
      </div>
      <div class="title-container">
        <p class="name">{{ user.FirstName + " " + user.LastName }}</p>
        <span v-for="role in user.Roles" :key="role.RoleId" class="role">{{
          role.Name
        }}</span>
      </div>
      <div
        v-if="canEdit"
        @click="emitUserEdit"
        class="edit-container edit-icon align-self-start"
      >
        <img class="edit-btn" src="../../assets/icons/edit.png" alt />
      </div>
    </div>
    <span class="line"></span>
    <div class="user-item-body">
      <ul>
        <li
          v-for="instrument in user.Instruments"
          :key="instrument.InstrumentId"
        >
          {{ instrument.Name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["user"],
  data() {
    return {
      canEdit: false,
    };
  },
  methods: {
    emitUserEdit(e) {
      e.stopPropagation();
      this.$emit("userEditClicked", this.user.UserId);
    },
    goToProfile() {
      let loggedInUserId = parseInt(localStorage.getItem("user"));
      if (this.user.UserId === loggedInUserId) {
        this.$router.push("/Home/Profile");
      } else {
        this.$router.push({
          name: "TargetProfile",
          params: {
            roleAccessList: ["Profesor", "Administrator", "Supervizor"],
            targetId: this.user.UserId,
            targetProfileRoleList: this.user.Roles,
          },
        });
        localStorage.setItem(
          "targetProfileRoleList",
          this.user.Roles.map((x) => x.Name)
        );
      }
    },
  },
  created() {
    this.canEdit = this.$store.state.services.checkRole("Administrator");
  },
};
</script>
<style scoped>
.users-container {
  background-color: #fafafa;
}
.user-item-header {
  display: flex;
  align-items: center;
}

p {
  margin: 0;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
}
.edit-icon {
  cursor: pointer;
  border-radius: 50%;
}
.user-item {
  height: 165px;
  width: calc(25% - 40px);
  float: left;
  margin: 20px;
  background-color: white;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.user-item:hover {
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);
}
.img-container {
  width: 30%;
  float: left;
  text-align: center;
}
.default-image {
}
.img-container img {
  border-radius: 50%;
  height: 47px;
  width: 47px;
  object-fit: cover;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16); */
}
.line {
  display: block;
  opacity: 0.12;
  border: solid 1px #039be5;
  width: 85%;
  margin: 5px auto 10px auto;
}
.title-container {
  width: 55%;
  float: left;
}
.name {
  font-size: 16px;
  font-weight: bold;
  color: #657786;
  margin-bottom: 5px;
}
.role::before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  line-height: 14px;
  background-color: #039be5;
  vertical-align: middle;
  margin-right: 5px;
}
ul li::before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  line-height: 14px;
  background-color: #039be5;
  vertical-align: middle;
  margin-right: 5px;
}
.role {
  opacity: 0.5;
  font-size: 14px;
  color: #657786;
  display: inline-block;
  margin: 0 5px;
}
.edit-container {
  width: 15%;
  float: left;
  text-align: center;
}

.user-item-body ul li {
  display: inline-block;
  width: 50%;
  float: left;
}
.edit-btn {
  width: 20px;
}

@media (max-width: 1300px) {
  .user-item {
    width: calc(50% - 40px);
  }
}

@media (max-width: 768px) {
  .user-item {
    width: calc(100% - 40px);
  }
}
</style>
